import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminTratamentos: Routes = [
  {
    path: 'tratamentos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'TRATAMENTOS',
      menuKey: 'TRATAMENTOS',
      breadcrumb: {
        label: 'Tratamentos',
        icon: 'mdi mdi-account-injury-outline'
      },
      backend_path: '/tratamentos'
    },
    loadChildren: () =>
      import('@app/modules/tratamentos/tratamento.module').then(
        m => m.TratamentoModule
      )
  }
];
